import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { rememberDestination } from '../../utils/returnTo'

// Resolves auth state before making a routing decision, so a signed-in
// visitor never flashes the sign-in page. Unauthenticated visitors are sent
// to "/" with the intended destination preserved in location state.
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <p className="px-5 py-10 text-body-s text-ink-3">Loading…</p>
  }

  if (!user) {
    // This is the last moment the intended destination exists anywhere. Written here as
    // well as handed to the router, because the router's copy does not survive a reload
    // and the reloading flows are the ones that lose people — see utils/returnTo.
    // Idempotent, so StrictMode's second render writes the same string over itself.
    rememberDestination(location)

    return <Navigate to="/" state={{ from: location }} replace />
  }

  return children
}
